module.exports = __webpack_public_path__ + "img/documents.a3b893c2.svg";